import type { User } from "../types";

export function getGuestDisplayName(friend: Pick<User, "FirstName" | "LastName">): string {
  return [friend.FirstName, friend.LastName]
    .filter((p) => p != null && String(p).trim() !== "")
    .join(" ");
}

export function parseGuestDisplayName(value: string): Pick<User, "FirstName" | "LastName"> {
  const trimmed = value.trim();
  if (!trimmed) {
    return { FirstName: "", LastName: "" };
  }
  const parts = trimmed.split(/\s+/);
  return {
    FirstName: parts[0] ?? "",
    LastName: parts.length > 1 ? parts.slice(1).join(" ") : "",
  };
}